// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* for now we disable this, since it caused issue to some mobile screen when resized */
.hidden-body {
  /* @apply !overflow-hidden; */
  position: fixed;
  height: 100%;
  overflow: hidden !important;
  width: 100%;
}

div[class^='react-joyride__spotlight'] {
  border-radius: 1rem /* 16px */ !important;
}

div[class^='react-joyride__tooltip'] {
  padding: 1rem /* 16px */ !important;
  border-radius: 1rem /* 16px */ !important;
}

div[class^='react-joyride__tooltip'] > button {
  padding: 1rem /* 16px */ !important;
}

div[class^='react-joyride__tooltip'] > div > div {
  padding: 0px !important;
}

p.tour-title {
  text-align: left;
  font-size: 14px;
  line-height: 1rem /* 16px */;
  font-weight: 900;
  margin-bottom: 0.5rem /* 8px */;
}

p.tour-desc {
  text-align: left;
  font-size: 14px;
  font-weight: 500;
}

span.tour-progress {
  font-size: 10px;
  position: absolute;
  bottom: 1rem /* 16px */;
  left: 1rem /* 16px */;
  line-height: 1rem /* 16px */;
}

div[class^='react-joyride__tooltip'] button[title='NEXT'],
div[class^='react-joyride__tooltip'] button[title='CLOSE'] {
  font-size: 14px !important;
  font-weight: 700;
  padding: 0px !important;
  outline-width: 0px;
  text-transform: uppercase;

  /* !text-primary-apricot */
  --tw-text-opacity: 1 !important;
  color: rgb(247 148 30 / var(--tw-text-opacity)) !important;

  /* !bg-white */
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}

div[class^='react-joyride__tooltip'] button[title='Back'] {
  display: none !important;
}

div[class^='__floater __floater__open'][x-placement='bottom-start']
  div[class^='__floater__arrow']
  span {
  left: 1.25rem /* 20px */ !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/tour/Tour.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;;EAEzB,0BAA0B;EAC1B,+BAA+B;EAC/B,0DAA0D;;EAE1D,cAAc;EACd,6BAA6B;EAC7B,oEAAoE;AACtE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,mCAAmC;AACrC","sourcesContent":["/* for now we disable this, since it caused issue to some mobile screen when resized */\n.hidden-body {\n  /* @apply !overflow-hidden; */\n  position: fixed;\n  height: 100%;\n  overflow: hidden !important;\n  width: 100%;\n}\n\ndiv[class^='react-joyride__spotlight'] {\n  border-radius: 1rem /* 16px */ !important;\n}\n\ndiv[class^='react-joyride__tooltip'] {\n  padding: 1rem /* 16px */ !important;\n  border-radius: 1rem /* 16px */ !important;\n}\n\ndiv[class^='react-joyride__tooltip'] > button {\n  padding: 1rem /* 16px */ !important;\n}\n\ndiv[class^='react-joyride__tooltip'] > div > div {\n  padding: 0px !important;\n}\n\np.tour-title {\n  text-align: left;\n  font-size: 14px;\n  line-height: 1rem /* 16px */;\n  font-weight: 900;\n  margin-bottom: 0.5rem /* 8px */;\n}\n\np.tour-desc {\n  text-align: left;\n  font-size: 14px;\n  font-weight: 500;\n}\n\nspan.tour-progress {\n  font-size: 10px;\n  position: absolute;\n  bottom: 1rem /* 16px */;\n  left: 1rem /* 16px */;\n  line-height: 1rem /* 16px */;\n}\n\ndiv[class^='react-joyride__tooltip'] button[title='NEXT'],\ndiv[class^='react-joyride__tooltip'] button[title='CLOSE'] {\n  font-size: 14px !important;\n  font-weight: 700;\n  padding: 0px !important;\n  outline-width: 0px;\n  text-transform: uppercase;\n\n  /* !text-primary-apricot */\n  --tw-text-opacity: 1 !important;\n  color: rgb(247 148 30 / var(--tw-text-opacity)) !important;\n\n  /* !bg-white */\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;\n}\n\ndiv[class^='react-joyride__tooltip'] button[title='Back'] {\n  display: none !important;\n}\n\ndiv[class^='__floater __floater__open'][x-placement='bottom-start']\n  div[class^='__floater__arrow']\n  span {\n  left: 1.25rem /* 20px */ !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
